import script from "./ProfileLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProfileLayout.vue?vue&type=style&index=0&id=200bd24b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200bd24b"]])

export default __exports__